module.exports = {"base_url":"https://realisedrate.com/","isFirebaseEnabled":false,"gaTrakingId":"UA-144181167-2","firebase_config":{"apiKey":"AIzaSyBtl8esynGKR9xMBakkGWhbRKkiUVO3rpc","authDomain":"summary-adder-779429.firebaseapp.com","databaseURL":"https://summary-adder-779429.firebaseio.com","projectId":"summary-adder-779429","storageBucket":"summary-adder-779429.appspot.com","messagingSenderId":"694130456524","appId":"1:694130456524:web:7f4b1e0a3c830856214f69"},"captcha_site_key":"6LfbrMMUAAAAAHhAsYddiRwiPKkkGdd1PbLQr3Yi","isFallbackEnabled":false}


//////////////////
// WEBPACK FOOTER
// ./src/config/config.json
// module id = 308
// module chunks = 0